var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\xC9l\\xE9ments",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icones/Action/Ajouter/Fill/Noir",
    className: "st0-fill"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19,11 L13,11 L13,5 C13,4.448 12.553,4 12,4 C11.447,4 11,4.448 11,5 L11,11 L5,11 C4.447,11 4,11.448 4,12 C4,12.552 4.447,13 5,13 L11,13 L11,19 C11,19.552 11.447,20 12,20 C12.553,20 13,19.552 13,19 L13,13 L19,13 C19.553,13 20,12.552 20,12 C20,11.448 19.553,11 19,11",
    id: "Fill-1",
    transform: "rotate(45 12 12)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBlack);
export default __webpack_public_path__ + "static/media/close_black.87df9ea361c97514c7936e85ce9edd92.svg";
export { ForwardRef as ReactComponent };